import { Flex } from '@chakra-ui/react'
import { useSettingsState } from '~/atoms/SettingsState'
import { useCallQueue } from '~/hooks/useCallQueue'
import WebPhoneView from '~/pages/WebPhone/WebPhoneView'

import { OnboardingView } from './OnboardingView'
import { StatusDisplay } from './StatusDisplay'

const WebPhonePage = () => {
  const { canUseWebPhone } = useSettingsState()
  const { setWebPhoneEnabled } = useSettingsState()
  const { currentCustomStatus, formattedTime } = useCallQueue()

  const handleActivateButtonClick = () => {
    setWebPhoneEnabled(true)
  }

  return (
    <Flex
      h="full"
      w="full"
      justify="center"
      bg="bg.subtle"
      flex={'1 0 0'}
      alignSelf={'stretch'}
      overflowY={'auto'}
    >
      {canUseWebPhone && (
        <StatusDisplay
          currentCustomStatus={currentCustomStatus}
          formattedTime={formattedTime}
        />
      )}
      {canUseWebPhone &&
        (!currentCustomStatus ||
          currentCustomStatus?.availability == 'Online') && <WebPhoneView />}
      {!canUseWebPhone && (
        <OnboardingView onActivateButtonClick={handleActivateButtonClick} />
      )}
    </Flex>
  )
}

export default WebPhonePage
